import dev from './dev.json';
import staging from './staging.json';
import prod from './prod.json';
import { Env } from '../utils/constants';

const environment = (env: string) => {
  switch (env) {
    case Env.Prod:
      return prod;
    case Env.Staging:
      return staging;
    case Env.Dev:
    default:
      return dev;
  }
};
export default environment;
